import { jsx } from "react/jsx-runtime";
import CloseCircle from "@crehana/compass.icons.fill/CloseCircle";
const CleanIcon = ({ onClick })=>/*#__PURE__*/ jsx("button", {
        type: "button",
        className: "tw-flex tw-items-center tw-mr-1.6",
        onClick: onClick,
        children: /*#__PURE__*/ jsx(CloseCircle, {
            size: 16,
            className: "tw-text-neutral-light-600 hover:tw-text-primary-light-500 dark:tw-text-neutral-dark-500 dark:hover:tw-text-primary-dark-400"
        })
    });
const CloseIcon = CleanIcon;
export default CloseIcon;
